import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, { KTPaginationColor } from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useWindowSize from 'hooks/useWindowSize';
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import * as ExcelJS from 'exceljs';
import DialogAddIdentifierView from '../DialogAddIdentifierView';

ChargeIdentifierListView.propTypes = {};

function ChargeIdentifierListView(props) {
  const { operatorList } = useAgency();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const [filter, setFilter] = useState(ChargeHelper.Filter.chargeIdentifierList);
  const [identifierList, setIdentifierList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const params = _.pickBy(filter, (value) => value !== null && value !== undefined && value !== '');
    ChargeHelper.API.Identifier.requestGetIdentifierList(params)
      .then((response) => {
        setIdentifierList(response?.vehicleIdentities ?? []);
        setTotal(response?.total ?? 0);
      })
      .finally(() => setIsLoading(false));
  }, [filter]);

  const fullColumns = useMemo(() => {
    return [
      {
        id: 'EVCC_ID',
        name: UIHelper.buildTableColumn('Mã MAC/EVCC'),
        selector: (row) => (
          <span style={UIHelper.buildFontStyle('600', '13px', AppColors.primary)}>
            {row?.code}
          </span>
        ),
        minWidth: '200px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'OPERATOR',
        name: UIHelper.buildTableColumn('Đối tác sạc'),
        selector: (row) => (
          <span className="cursor-pointer hover-opacity-60">
            {row?.vehicleIdentityPartner?.name}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_BRAND',
        name: UIHelper.buildTableColumn('Hãng xe'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              if (row?.vehicle?.model?.brand?.brandId)
                Utils.openInNewTab(`${AppRoute.manageVehicleBrand}/${row?.vehicle?.model?.brand?.brandId}`);
            }}
          >
            {row?.vehicle?.model?.brand?.name}
          </span>
        ),
        minWidth: '160px',
        style: tableStyle.columns.link,
      },
      {
        id: 'VEHICLE_MODEL',
        name: UIHelper.buildTableColumn('Dòng xe'),
        selector: (row) => row?.vehicle?.model?.name,
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PLATE',
        name: UIHelper.buildTableColumn('Biển số xe'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              if (row?.vehicle?.vehicleId)
                Utils.openInNewTab(`${AppRoute.vehicleList}/${row?.vehicle?.vehicleId}`);
            }}
          >
            {row?.vehicle?.plate}
          </span>
        ),
        minWidth: '160px',
        style: tableStyle.columns.link,
      },
      {
        id: 'DRIVER',
        name: UIHelper.buildTableColumn('Tên khách hàng'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              if (row?.vehicle?.userId)
                Utils.openInNewTab(`${AppRoute.customerList}/${row?.vehicle?.userId}`);
            }}
          >
            {row?.vehicle?.user?.fullname}
          </span>
        ),
        minWidth: '200px',
        style: tableStyle.columns.link,
      },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng thái sạc'),
        selector: (row) => (
          <KTLabel
            text={ChargeHelper.Utils.getIdentifierStatusName(row?.status)}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${ChargeHelper.Utils.getIdentifierStatusColor(row?.status)}`}
          />
        ),
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        maxWidth: '140px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          if (!isAdmin) return null;
          const btnClass = 'btn btn-sm btn-clean btn-icon btn-table-action';
          const iconStyle = { fontSize: '1.1rem' };
          const editBtn = (
            <a className={btnClass} onClick={() => handleAddNew(row)}>
              <i className="fa-regular fa-edit" style={iconStyle} />
            </a>
          );
          const toggleBtn = row?.status === ChargeConstants.ChargeIdentifierStatus.ACTIVE ? (
            <a className={btnClass} onClick={() => ChargeHelper.UI.Identifier.showDialogConfirmBlockIdentifier(row, handleRefresh)}>
              <i className="fa-regular fa-lock" style={iconStyle} />
            </a>
          ) : (
            <a className={btnClass} onClick={() => ChargeHelper.UI.Identifier.showDialogConfirmAllowIdentifier(row, handleRefresh)}>
              <i className="fa-regular fa-play" style={iconStyle} />
            </a>
          );
          if (row?.vehicle) {
            return (
              <div className="d-flex align-items-center gap-2">
                {editBtn}
                {toggleBtn}
                <a className={btnClass} onClick={() => ChargeHelper.UI.Identifier.showDialogConfirmDeleteIdentifier(row, handleRefresh)}>
                  <i className="fa-regular fa-trash-can" style={iconStyle} />
                </a>
              </div>
            );
          }
          return (
            <div className="d-flex align-items-center gap-2">
              {editBtn}
              {toggleBtn}
              {UIHelper.buildMoreActionsButton([
                {
                  text: 'Gắn mã định danh',
                  iconElement: <i className="fa-regular fa-hashtag" style={iconStyle} />,
                  click: () => ChargeHelper.UI.Identifier.showDialogAssignVehicle(row, handleRefresh),
                },
                {
                  text: 'Xóa mã định danh',
                  iconElement: <i className="fa-regular fa-trash-can" style={iconStyle} />,
                  click: () => ChargeHelper.UI.Identifier.showDialogConfirmDeleteIdentifier(row, handleRefresh),
                },
              ], false)}
            </div>
          );
        },
      },
    ];
  }, []);

  const windowSize = useWindowSize();

  const statusDropdownItems = useMemo(
    () => [{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.chargeIdentifierStatusOptions],
    []
  );

  const operatorDropdownItems = useMemo(
    () => [
      { name: 'Tất cả', value: '' },
      ...(operatorList ?? []).map((op) => ({ name: op.name, value: op.operatorId?.toString() })),
    ],
    [operatorList]
  );



  const handleRefresh = () => {
    setFilter({ ...ChargeHelper.Filter.chargeIdentifierList });
    setSelectedRows([]);
    setToggleCleared((v) => !v);
  };

  const handleRowsSelected = useCallback((rows) => setSelectedRows(rows), []);

  const handleAddNew = (row) => {
    AppCustomDialogHelper.show(
      !!row ? 'Sửa mã định danh' : 'Thêm mã định danh',
      <DialogAddIdentifierView
        item={row}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'md',
      false,
      true
    );
  };

  const handleBulkAllow = () => {
    if (!selectedRows.length) return;
    const ids = selectedRows.map((r) => r.vehicleIdentityId);
    ChargeHelper.UI.Identifier.showDialogConfirmBulkAllowIdentifier(ids, handleRefresh);
  };

  const handleBulkBlock = () => {
    if (!selectedRows.length) return;
    const ids = selectedRows.map((r) => r.vehicleIdentityId);
    ChargeHelper.UI.Identifier.showDialogConfirmBulkBlockIdentifier(ids, handleRefresh);
  };

  const handleExportExcel = async (exportData, params) => {
    if (_.isEmpty(exportData)) {
      ToastHelper.showError('Không có dữ liệu để tải xuống');
      return;
    }

    const sheetFileName =
      'Danh_sach_ma_dinh_danh_' +
      moment(params.from).format('DDMMYYYY') +
      '_' +
      moment(params.to).format('DDMMYYYY');
    const ext = '.xlsx';
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(sheetFileName, {
      headerFooter: { firstHeader: sheetFileName },
    });

    sheet.mergeCells('A1:H1');
    sheet.getCell('A1').value = `DANH SÁCH MÃ ĐỊNH DANH XE (${moment(params.from).format('DD/MM/YYYY')} - ${moment(params.to).format('DD/MM/YYYY')})`;
    sheet.getCell('A1').font = { name: 'Times New Roman', family: 4, size: 11, bold: true, color: { argb: 'FFFFFFFF' } };
    sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    sheet.getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '29618E' } };
    sheet.getRow(1).height = 25;

    const headers = ['STT', 'Mã MAC/EVCC', 'Đối tác sạc', 'Hãng xe', 'Dòng xe', 'Biển số xe', 'Tên khách hàng', 'Trạng thái sạc'];
    const headerRow = sheet.getRow(2);
    headers.forEach((h, i) => {
      headerRow.getCell(i + 1).value = h;
      headerRow.getCell(i + 1).font = { name: 'Times New Roman', family: 4, size: 11, bold: true };
      headerRow.getCell(i + 1).alignment = { vertical: 'middle', horizontal: 'center' };
      headerRow.getCell(i + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
      headerRow.getCell(i + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    headerRow.height = 22;

    exportData.forEach((row, index) => {
      const dataRow = sheet.getRow(index + 3);
      const cells = [
        index + 1,
        row?.code ?? '',
        row?.vehicleIdentityPartner?.name ?? '',
        row?.vehicle?.model?.brand?.name ?? '',
        row?.vehicle?.model?.name ?? '',
        row?.vehicle?.plate ?? '',
        row?.vehicle?.user?.fullname ?? '',
        ChargeHelper.Utils.getIdentifierStatusName(row?.status),
      ];
      cells.forEach((val, i) => {
        dataRow.getCell(i + 1).value = val;
        dataRow.getCell(i + 1).font = { name: 'Times New Roman', family: 4, size: 11 };
        dataRow.getCell(i + 1).alignment = { vertical: 'middle', horizontal: i === 0 ? 'center' : 'left' };
        dataRow.getCell(i + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });

    const colWidths = [6, 22, 22, 18, 18, 16, 24, 18];
    colWidths.forEach((w, i) => { sheet.getColumn(i + 1).width = w; });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = sheetFileName + ext;
      anchor.click();
      window.URL.revokeObjectURL(url);
      ToastHelper.showSuccess('Tải xuống file Excel thành công');
      AppCustomDialogHelper.hide();
    });
  };

  return (
    <div>
      {UIHelper.buildCard(
        <div className="pb-4">
          {/* header */}
          <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div className="d-flex flex-column">
              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                Quản lý mã định danh
              </span>
              <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                Tổng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                  {Utils.formatNumber(total)} mã
                </span>
              </span>
            </div>
            {isAdmin && (
              <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap">
                {UIHelper.buildNegativeButton(
                  'Tải lên excel',
                  () => ChargeHelper.UI.Excel.showDialogUploadIdentifierExcel(handleRefresh),
                  <i className="fa-regular fa-upload" />
                )}
                {UIHelper.buildBlueButton(
                  'Tải xuống',
                  () => {
                    ChargeHelper.UI.Excel.showDialogDownloadWithDateRange(
                      ChargeHelper.Filter.chargeIdentifierList,
                      async (params) => {
                        try {
                          const response = await ChargeHelper.API.Identifier.requestGetIdentifierList({ ...params, limit: 1000000, page: 0 });
                          await handleExportExcel(response?.vehicleIdentities ?? [], params);
                        } catch (error) {
                          ToastHelper.showError('Lỗi khi lấy dữ liệu');
                        }
                      },
                    );
                  },
                  <i className="fa-regular fa-download" />
                )}
                {UIHelper.buildGreenButton(
                  'Thêm mã định danh',
                  () => handleAddNew(null),
                  <i className="fa-regular fa-circle-plus" />
                )}
              </div>
            )}
          </div>

          {/* filters */}
          <div className="row m-0 p-0 px-2">
            {windowSize.width >= 768 && (
              <div className="col-lg-3 col-md-4 mb-4 px-2">
                {UIHelper.buildFormLabel('Tìm kiếm')}
                <KTFormSearch
                  name="search"
                  placeholder="Theo mã MAC/EVCC, biển số xe..."
                  value={filter.q}
                  onSubmit={(text) => {
                    ChargeHelper.Filter.chargeIdentifierList = {
                      ...ChargeHelper.Filter.chargeIdentifierList,
                      q: text,
                      page: 0,
                    };
                    handleRefresh();
                  }}
                />
              </div>
            )}
            {windowSize.width >= 992 && (
              <div className="col-lg-2 mb-4 px-2">
                {UIHelper.buildFormLabel('Trạng thái sạc')}
                <KTBSDropdown
                  name="status"
                  toggleElement={
                    <button
                      className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                      type="button"
                    >
                      {_.find(ChargeHelper.Data.chargeIdentifierStatusOptions, (item) => item.value === ChargeHelper.Filter.chargeIdentifierList?.status)?.name ?? 'Tất cả'}
                    </button>
                  }
                  selectedValue={ChargeHelper.Filter.chargeIdentifierList?.status}
                  dropdownMenuItems={statusDropdownItems}
                  dropdownMenuClassName="overflow-auto w-100"
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  onChange={(value) => {
                    ChargeHelper.Filter.chargeIdentifierList = {
                      ...ChargeHelper.Filter.chargeIdentifierList,
                      status: value,
                      page: 0,
                    };
                    handleRefresh();
                  }}
                  isDropdownForm={true}
                />
              </div>
            )}
            {windowSize.width >= 992 && (
              <div className="col-lg-2 mb-4 px-2">
                {UIHelper.buildFormLabel('Đối tác sạc')}
                <KTBSDropdown
                  name="vehicleIdentityPartnerId"
                  toggleElement={
                    <button
                      className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                      type="button"
                    >
                      {_.find(operatorList, (item) => item.operatorId?.toString() === ChargeHelper.Filter.chargeIdentifierList?.vehicleIdentityPartnerId?.toString())?.name ?? 'Tất cả'}
                    </button>
                  }
                  selectedValue={ChargeHelper.Filter.chargeIdentifierList?.vehicleIdentityPartnerId}
                  dropdownMenuItems={operatorDropdownItems}
                  dropdownMenuClassName="overflow-auto w-100"
                  dropdownMenuStyle={{ maxHeight: '30vh' }}
                  onChange={(value) => {
                    ChargeHelper.Filter.chargeIdentifierList = {
                      ...ChargeHelper.Filter.chargeIdentifierList,
                      vehicleIdentityPartnerId: value,
                      page: 0,
                    };
                    handleRefresh();
                  }}
                  isDropdownForm={true}
                />
              </div>
            )}
            {isAdmin && selectedRows.length > 0 && (
              <div className="col mb-4 px-2 d-flex align-items-end justify-content-end gap-3">
                {selectedRows.some((r) => r.status !== ChargeConstants.ChargeIdentifierStatus.ACTIVE) &&
                  UIHelper.buildGreenButton(`Cấp phép sạc (${selectedRows.length})`, handleBulkAllow)
                }
                {selectedRows.some((r) => r.status === ChargeConstants.ChargeIdentifierStatus.ACTIVE) &&
                  UIHelper.buildNegativeButton(`Chặn sạc (${selectedRows.length})`, handleBulkBlock)
                }
              </div>
            )}
          </div>

          {/* table */}
          <div className="px-4">
            <KTTable
              columns={fullColumns}
              items={identifierList}
              selectableRows={isAdmin}
              striped={false}
              compactGrid={false}
              onSelectedRowsChanged={handleRowsSelected}
              clearSelectedRows={toggleCleared}
              noDataComponent={UIHelper.buildEmptyNoData('Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.')}
            />
          </div>

          {/* pagination */}
          <div className="px-4 mt-2">
            <KTPagination
              currentPage={filter.page + 1}
              rowCount={total}
              rowsPerPage={filter.limit}
              currentItemInPageCount={identifierList?.length}
              onChangePage={(newPage) => {
                ChargeHelper.Filter.chargeIdentifierList = {
                  ...ChargeHelper.Filter.chargeIdentifierList,
                  page: parseInt(newPage) - 1,
                };
                handleRefresh();
              }}
              onChangeRowsPerPage={(newRowsPerPage) => {
                ChargeHelper.Filter.chargeIdentifierList = {
                  ...ChargeHelper.Filter.chargeIdentifierList,
                  limit: parseInt(newRowsPerPage),
                  page: 0,
                };
                handleRefresh();
              }}
              loading={isLoading}
              color={KTPaginationColor.success}
              appendText="mã"
            />
          </div>
        </div>,
        false
      )}
    </div>
  );
}

export default ChargeIdentifierListView;
